import * as React from 'react';

import { createIcon } from '../Icon';
export const VideoIcon = createIcon(
  <React.Fragment>
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect height={14} rx={2} ry={2} width={15} x={1} y={5} />
  </React.Fragment>,
  'VideoIcon'
);
